module.exports = __webpack_public_path__ + "img/banana-circle.ea40a2d6.gif";